import React, { useEffect } from "react"

import { IDateFieldProperties } from "./generic/form/DatePickerField"
import DatePickerField from "./generic/form/DatePickerField"
import * as Utils from "./Utils"
import { useAppSelector } from "../app/hooks"
import { isAfter } from "date-fns"

interface Props extends IDateFieldProperties {
  name?: string
  caption?: string
  onChange: (name: string, val: string, isValid: boolean) => void
  value?: string
  isAddPage?: boolean
}

const SeasonDatePicker: React.FunctionComponent<Props> = ({
  name,
  value,
  caption,
  onChange,
  onSelectDate,
  disabled,
  touched,
  autoFocus,
  readonly,
  required,
  showIcon,
  dropdownId,
  placement,
  hasChanges,
  placeholder,
  isEmpty,
  hasError,
  isAddPage,
  dateCanBeNull,
  max,
  min,
  displayFormat,
  dateHasErrText
}) => {
  const { season } =
    useAppSelector(
      (state) => state["selectionReducer"].airportSeasonsSelector
    ) || {}
  const seasonsData = useAppSelector((state) => state["appReducer"].seasons)
  const selectedSeasonsData = seasonsData.find((sd) => sd.code === season)

  useEffect(() => {
    if (selectedSeasonsData && value) {
      if (
        value < selectedSeasonsData.startDate ||
        value > selectedSeasonsData.endDate
      ) {
        const updDate = Utils.GetValidDateInSeason(
          selectedSeasonsData.startDate,
          selectedSeasonsData.endDate,
          Utils.formatDateShort(new Date(value))
        )

        if (!isAddPage) {
          onChange(
            name,
            updDate ? Utils.formatDate(updDate) : null,
            required && isEmpty ? (updDate === null ? false : true) : false
          )
        }
      }
    }
  }, [selectedSeasonsData, value, name, onChange, required, isEmpty, isAddPage])

  const seasonMaxDate = selectedSeasonsData
    ? Utils.convertDateToUTC(new Date(selectedSeasonsData.endDate))
    : null
  const maxIsAfterSeasonMaxDate = isAfter(max, seasonMaxDate)
  const minDate =
    min !== undefined
      ? min
      : selectedSeasonsData
      ? Utils.convertDateToUTC(new Date(selectedSeasonsData.startDate))
      : null
  const maxDate =
    max !== undefined && !maxIsAfterSeasonMaxDate
      ? max
      : selectedSeasonsData
      ? Utils.convertDateToUTC(new Date(selectedSeasonsData.endDate))
      : null

  return (
    <DatePickerField
      name={name}
      dateCanBeNull={dateCanBeNull}
      caption={caption}
      value={value ? Utils.convertDateToUTC(new Date(value)) : null}
      displayFormat="ddMMM"
      readonly={readonly}
      max={maxDate}
      min={minDate}
      styles="text-transform: uppercase"
      formatDateVal
      onChange={onChange}
      onSelectDate={onSelectDate}
      hasError={hasError}
      disabled={disabled}
      required={required}
      touched={touched}
      showIcon={showIcon}
      dropdownId={dropdownId}
      autoFocus={autoFocus}
      placement={placement}
      hasChanges={hasChanges}
      placeholder={placeholder}
      isEmpty={isEmpty}
      dateHasErrText={dateHasErrText}
    />
  )
}

export default SeasonDatePicker

